import React from 'react';
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionPrivacyPolicy from "../../../components/sections/front/PrivacyPolicy/SectionPrivacyPolicy";
const PrivacyPolicy = () => {
  return (
    <>
      <PageBanner title={"Privacy Policy"} image={BannerImage} />
      <SectionPrivacyPolicy/>
      <OurPartners />
    </>
  );
};

export default PrivacyPolicy;